import React from 'react';
import { useHistory } from 'react-router-dom';
import useHeaderHeight from '../../hooks/useHeaderHeight';
import './ForbiddenPage.css'; // Import CSS module or stylesheet

const ForbiddenPage = () => {
  useHeaderHeight();
  const history = useHistory();

  return (
    <div className="forbidden-page">
      <h1>403 - Forbidden</h1>
      <p>You don’t have permission to access this page.</p>
      <button onClick={() => history.push('/')} className="forbidden-button">
        Return to Home
      </button>
    </div>
  );
};

export default ForbiddenPage;
